import { render, staticRenderFns } from "./RyomaRadioButton.vue?vue&type=template&id=3084f5e4&scoped=true&"
import script from "./RyomaRadioButton.vue?vue&type=script&lang=js&"
export * from "./RyomaRadioButton.vue?vue&type=script&lang=js&"
import style0 from "./RyomaRadioButton.vue?vue&type=style&index=0&id=3084f5e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3084f5e4",
  null
  
)

export default component.exports